import styled from '@emotion/styled'
import { TFunction } from 'i18next'

import { color, theme } from '../../Theme'
import { Defect } from '../../types'
import { Status } from '../create-defect/types'
import DefectsRow from './DefectsRow'

type Props = {
  t: TFunction
  defects: Array<Defect>
  nightMode: boolean
  status: Status
  grouped?: boolean
}

type ListContainerProps = {
  status: Status
  nightMode?: boolean
  grouped?: boolean
}

const ListContainer = styled.div<ListContainerProps>`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  ${(props) => (props.grouped ? theme.spacing.top('tiny') : theme.spacing.top('large'))}
  ${(props) => (props.grouped ? theme.spacing.bottom('smallest') : theme.spacing.bottom('larger'))}
  ${(p) => p.status === 'closed' && `color: ${color(p.nightMode ? 'nightGray' : 'grayDark')}`};
`

const DefectsList = ({ defects, t, nightMode, status, grouped }: Props): JSX.Element => {
  return (
    <ListContainer status={status} nightMode={nightMode} grouped={grouped}>
      {defects.map((defect) => (
        <DefectsRow
          key={defect.id}
          defect={defect}
          t={t}
          nightMode={nightMode}
          status={status}
          open={defect.open}
        />
      ))}
    </ListContainer>
  )
}

export default DefectsList
